import { combineReducers } from 'redux-immutable'

import ribbonReducer from './components/Ribbon/reducer'
import workspaceReducer from './components/Workspace/reducer'

const rootReducer = combineReducers({
    ribbon: ribbonReducer,
    workspace: workspaceReducer,
})

export default rootReducer
